import React from 'react';
import { Icon } from 'tea-component';
import { MainContentCmp } from '@/pages/aigc/pages/Agent/ChatPage/components/SubComp';
import type { IMemorySummarySectionProps } from '../../types';

const MemorySummarySection: React.FC<IMemorySummarySectionProps> = ({
  title,
  emptyText,
  hasMemory,
  formattedMemory,
  loading = false,
}) => (
  <div className="dba-memory-summary">
    <div className="dba-memory-summary-title">{title}</div>
    <div className="dba-memory-summary-content">
      {loading ? (
        <div className="dba-memory-summary-markdown">
          <div className="dba-memory-summary-loading-icon">
            <Icon type="loading" />
          </div>
        </div>
      ) : hasMemory ? (
        <div className="dba-memory-summary-markdown">
          <MainContentCmp
            value={formattedMemory}
            isShowReference={false}
          />
        </div>
      ) : (
        <div className="dba-memory-summary-empty">{emptyText}</div>
      )}
    </div>
  </div>
);

export default MemorySummarySection;
